var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false
    ? _c("div", { staticClass: "dt-rec" }, [
        _c(
          "ul",
          { staticClass: "recommend", staticStyle: { display: "flex" } },
          [
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "/qlist/" + _vm.generateRandomNum() + "/",
                    uigs: "bottom_hot_recommend",
                    title: "今日热点推荐",
                  },
                },
                [_vm._v("\n        今日热点推荐\n      ")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "/qlist/" + _vm.generateRandomNum() + "/",
                    uigs: "bottom_hot_query",
                    title: "热搜词排行榜",
                  },
                },
                [_vm._v(" 热搜词排行榜 ")]
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }